<template>
  <div
    :class="{
      'dropzone rounded': styled,
      'dropzone-highlight': styled && counter > 0,
      'dropzone-clear': clear && styled,
    }"
    @click="$emit('click')"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DropZone",

  emits: ["dragging", "end-dragging", "add", "drop", "click"],

  props: {
    clear: { required: false, default: false, type: Boolean },
    styled: { required: false, default: true, type: Boolean },
    disabled: { required: false, default: false, type: Boolean },
  },

  data() {
    return {
      counter: 0,
    }
  },

  watch: {
    counter(counter) {
      if (counter !== 0) {
        this.$emit("dragging")
      } else {
        this.$emit("end-dragging")
      }
    },
  },

  mounted() {
    const app = document.querySelector("body")
    app.addEventListener("dragenter", this.dragEnter)
    app.addEventListener("dragleave", this.dragLeave)
    app.addEventListener("drop", this.dropped)
    app.addEventListener("dragover", this.dragOver)
  },

  unmounted() {
    const app = document.querySelector("body")
    app.removeEventListener("dragenter", this.dragEnter)
    app.removeEventListener("dragleave", this.dragLeave)
    app.removeEventListener("drop", this.dropped)
    app.removeEventListener("dragover", this.dragOver)
  },

  methods: {
    dropped(e) {
      if (this.disabled) {
        return
      }

      e.preventDefault()
      e.stopPropagation()

      this.$emit("drop", e)
      this.$emit("add", e.dataTransfer.files)
      this.counter = 0
    },

    dragEnter(e) {
      e.preventDefault()
      e.stopPropagation()

      this.counter++
    },

    dragLeave(e) {
      e.preventDefault()
      e.stopPropagation()
      this.counter--
    },

    dragOver(e) {
      e.preventDefault()
      e.stopPropagation()
    },
  },
}
</script>

<style scoped>
.dropzone {
  position: relative;
}

.dropzone .dropzone-overlay {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 8px;
  z-index: 20;
}

.dropzone.dropzone-highlight .dropzone-overlay {
  display: block;
  border: 2px dotted #555;
  border-radius: 5px;
}
</style>
